module.exports = "<dialog name=\"{{dialogName}}\" class=\"onesite-base olyDialog olyDialog--modalDialog modalDialog\">\r\n    <div class=\"olyDialog-scrollableArea modalDialog-scrollableArea \">\r\n        <i class=\"icon-alert_exclamation modalDialog-icon\"></i>\r\n        <div class=\"modalDialog-textWrapper\">\r\n            <p class=\"modalDialog-textBody\">{{dialogMessage}}</p>\r\n        </div>\r\n        <a href=\"javascript:;\" ng-click=\"closeDialog()\" class=\"modalDialog-dismiss\">\r\n            <span class=\"sr-only\">close dialog</span>\r\n            <i class=\"icon-close_x\"></i>\r\n        </a>\r\n    </div>\r\n</dialog>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/dialog/dialog-template.html
 ** module id = 930
 ** module chunks = 1
 **/